/* Robotow content pages: form help, the one-time submit events, the YouTube facade and
   keyboard access for wide tables. Analytics go through window.rtTrack (assets/rt-events.js)
   with the names in the tracking plan. Nothing a visitor types is ever sent to analytics. */
(function () {
  "use strict";
  if (window.__rtPagesReady) return;
  window.__rtPagesReady = true;

  var PENDING = "rt_pending_";

  function track(name, params) { if (typeof window.rtTrack === "function") window.rtTrack(name, params); }
  function trackOnce(key, name, params) {
    if (typeof window.rtTrackOnce === "function") window.rtTrackOnce(key, name, params);
    else track(name, params);
  }
  function store() { try { var t = "__rt"; sessionStorage.setItem(t, t); sessionStorage.removeItem(t); return sessionStorage; } catch (e) { return null; } }
  function param(name) { try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; } }
  // Only a fit-library handle ever goes to analytics, never free text.
  function aircraftId() {
    var ac = param("ac") || "";
    return /^[a-z0-9][a-z0-9-]{0,79}$/.test(ac) ? ac : "";
  }

  /* ---------- forms ---------- */
  function fieldLabel(input) {
    var l = input.id && document.querySelector('label[for="' + input.id + '"] [data-rt-label-text]');
    return l ? l.textContent.trim() : "This field";
  }

  function problem(input) {
    var v = (input.value || "").trim();
    if (input.required && !v) {
      return input.getAttribute("data-rt-required-msg") || ("Enter " + fieldLabel(input).toLowerCase() + ".");
    }
    if (v && input.type === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      return "Enter an email address like name@example.com.";
    }
    return "";
  }

  function setError(input, msg) {
    var err = document.getElementById(input.id + "-error");
    var described = (input.getAttribute("aria-describedby") || "").split(" ").filter(function (x) { return x && x !== input.id + "-error"; });
    if (msg) {
      input.setAttribute("aria-invalid", "true");
      if (err) { err.textContent = msg; err.hidden = false; described.push(input.id + "-error"); }
    } else {
      input.removeAttribute("aria-invalid");
      if (err) { err.textContent = ""; err.hidden = true; }
    }
    if (described.length) input.setAttribute("aria-describedby", described.join(" "));
    else input.removeAttribute("aria-describedby");
  }

  function initForm(form) {
    form.noValidate = true;
    var summary = form.querySelector("[data-rt-form-summary]");
    var list = summary && summary.querySelector("ul");
    var fields = Array.prototype.slice.call(form.querySelectorAll("input, textarea, select")).filter(function (el) {
      return el.type !== "hidden" && el.type !== "submit" && el.type !== "checkbox";
    });

    // Clear an error as soon as the field is fixed, while typing, so nothing moves under the
    // pointer when the visitor goes to press the button.
    fields.forEach(function (el) {
      el.addEventListener("input", function () {
        if (el.getAttribute("aria-invalid") === "true" && !problem(el)) setError(el, "");
      });
    });

    form.addEventListener("submit", function (e) {
      var bad = [];
      fields.forEach(function (el) {
        var msg = problem(el);
        setError(el, msg);
        if (msg) bad.push({ el: el, msg: msg });
      });
      if (bad.length) {
        e.preventDefault();
        if (summary && list) {
          list.innerHTML = "";
          bad.forEach(function (b) {
            var li = document.createElement("li");
            var a = document.createElement("a");
            a.href = "#" + b.el.id;
            a.textContent = b.msg;
            a.addEventListener("click", function (ev) { ev.preventDefault(); b.el.focus(); });
            li.appendChild(a);
            list.appendChild(li);
          });
          summary.hidden = false;
          summary.focus();
        } else {
          bad[0].el.focus();
        }
        return;
      }
      // Remember that this visitor sent the form, so the success view fires its event once.
      var kind = form.getAttribute("data-rt-form");
      var s = store();
      if (kind && s) {
        try { s.setItem(PENDING + kind, JSON.stringify({ ac: aircraftId() })); } catch (err) {}
      }
    });
  }

  function initSuccess(el) {
    var kind = el.getAttribute("data-rt-form-success");
    var entry = el.getAttribute("data-entry") || "page";
    var s = store();
    var pending = null;
    if (s) {
      try { pending = JSON.parse(s.getItem(PENDING + kind) || "null"); } catch (e) { pending = null; }
      // Fire only right after a submit from this browser, never again on a reload.
      if (!pending) return;
      try { s.removeItem(PENDING + kind); } catch (e) {}
    }
    if (kind === "fit") {
      var ac = aircraftId() || (pending && /^[a-z0-9][a-z0-9-]{0,79}$/.test(pending.ac || "") ? pending.ac : "");
      trackOnce("form:fit", "rt_fit_request_submitted", { aircraft_id: ac, fit_result: "", entry_point: entry });
    } else if (kind === "fleet") {
      trackOnce("form:fleet", "rt_fleet_quote_submitted", { entry_point: entry });
    }
  }

  // ?airplane= fills the airplane field (links from the fit finder carry it).
  function prefillAirplane() {
    var v = param("airplane");
    if (!v) {
      // a no-match search hands its text over in sessionStorage, never in the URL
      try { v = sessionStorage.getItem("rt_airplane"); sessionStorage.removeItem("rt_airplane"); } catch (e) { v = null; }
    }
    if (!v) return;
    v = v.replace(/[<>]/g, "").slice(0, 80);
    Array.prototype.forEach.call(document.querySelectorAll("[data-rt-prefill='airplane']"), function (input) {
      if (!input.value) input.value = v;
    });
  }

  // The photo email carries the airplane in the subject. It opens the visitor's own mail app.
  function initMailto(a) {
    function update() {
      var base = a.getAttribute("data-subject") || "";
      var src = document.getElementById(a.getAttribute("data-airplane-field") || "");
      var plane = src && src.value ? src.value.replace(/[\r\n]/g, " ").trim().slice(0, 80) : (param("airplane") || "").slice(0, 80);
      var subject = plane ? base + ": " + plane : base;
      a.setAttribute("href", "mailto:" + a.getAttribute("data-to") + "?subject=" + encodeURIComponent(subject));
    }
    update();
    a.addEventListener("focus", update);
    a.addEventListener("mouseenter", update);
    a.addEventListener("click", update);
  }

  /* ---------- YouTube, click to load ---------- */
  function initYouTube(root) {
    var btn = root.querySelector("[data-rt-yt-play]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var id = root.getAttribute("data-video-id");
      if (!/^[A-Za-z0-9_-]{6,20}$/.test(id || "")) return;
      var q = ["autoplay=1", "rel=0", "playsinline=1", "modestbranding=1"];
      var start = parseInt(root.getAttribute("data-start"), 10);
      var end = parseInt(root.getAttribute("data-end"), 10);
      if (start > 0) q.push("start=" + start);
      if (end > 0) q.push("end=" + end);
      var frame = document.createElement("iframe");
      frame.src = "https://www.youtube-nocookie.com/embed/" + id + "?" + q.join("&");
      frame.title = root.getAttribute("data-title") || "Video";
      frame.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture; fullscreen");
      frame.setAttribute("allowfullscreen", "");
      frame.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
      var box = root.querySelector(".rt-yt-frame");
      box.innerHTML = "";
      box.appendChild(frame);
      root.classList.add("is-playing");
      frame.focus();
      trackOnce("yt:" + id, "rt_video_play", { video_name: id, entry_point: root.getAttribute("data-entry") || "page" });
    });
  }

  /* ---------- wide tables in posts: reachable by keyboard when they scroll ---------- */
  function initTableWraps() {
    Array.prototype.forEach.call(document.querySelectorAll(".rt-article-body .rt-table-wrap"), function (w) {
      if (w.scrollWidth > w.clientWidth + 2) {
        w.setAttribute("tabindex", "0");
        w.setAttribute("role", "region");
        w.setAttribute("aria-label", "Table, scrolls sideways");
      }
    });
  }

  function start() {
    prefillAirplane();
    Array.prototype.forEach.call(document.querySelectorAll("form[data-rt-form]"), initForm);
    Array.prototype.forEach.call(document.querySelectorAll("[data-rt-form-success]"), initSuccess);
    Array.prototype.forEach.call(document.querySelectorAll("a[data-rt-mailto]"), initMailto);
    Array.prototype.forEach.call(document.querySelectorAll("[data-rt-yt]"), initYouTube);
    initTableWraps();
    var ok = document.querySelector("[data-rt-form-success]");
    if (ok) ok.focus();
    var err = document.querySelector("[data-rt-form-summary]:not([hidden])");
    if (!ok && err) err.focus();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
